/* ==========================================================================
   NEBULIX · Ajustes de experiencia de compra (se carga en todas las páginas)
   1. Agregar al carrito SIEMPRE la variante que eligió el cliente
   2. Colores reales en los círculos de variantes
   3. Elegir variante y agregar desde las tarjetas, sin ir al producto
   4. Menú superior desplazable en computador (rueda, arrastre y flechas)
   5-7. Colecciones y búsqueda: selector rápido, filtros, orden y "Ver más"
   8. Botón "Escribir una reseña"
   9. Carrito lateral al agregar fuera de la página de producto
   ========================================================================== */
(function () {
  'use strict';
  var doc = document;
  var win = window;

  function ready(fn) {
    if (doc.readyState !== 'loading') fn();
    else doc.addEventListener('DOMContentLoaded', fn);
  }

  /* ---------- 1. Carrito: variante exacta ---------- */
  function setCounts(n) {
    doc.querySelectorAll('[data-nx-cart-count]').forEach(function (b) {
      b.textContent = n;
      b.setAttribute('data-count', n);
    });
  }

  function addExact(items) {
    var chain = Promise.resolve();
    items.forEach(function (it) {
      chain = chain.then(function () {
        return fetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(it.id), quantity: Math.max(1, parseInt(it.quantity, 10) || 1) }] })
        }).then(function (r) {
          if (r.ok) return r.json();
          return r.json().catch(function () { return {}; }).then(function (j) {
            var err = new Error((j && (j.description || j.message)) || 'No se pudo agregar al carrito.');
            err.status = r.status;
            throw err;
          });
        });
      });
    });
    return chain
      .then(function () { return fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } }); })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var N = win.NebulixPDP;
        if (N && N.renderCart) N.renderCart(cart);
        if (N && N.openDrawer) N.openDrawer();
        setCounts(cart.item_count);
        return cart;
      });
  }

  function patchCart() {
    var N = win.NebulixPDP;
    if (!N || N.__nxExact) return;
    N.__nxExact = true;
    N.addItems = function (items) {
      if (!items || !items.length) return Promise.reject(new Error('Nada para agregar.'));
      return addExact(items);
    };
  }
  patchCart();
  ready(patchCart);

  /* ---------- 2. Colores de variantes ---------- */
  var MAP = [
    ['gris plata', '#c0c0c0'], ['plata', '#c0c0c0'], ['silver', '#c0c0c0'],
    ['azul oleo', '#578bab'], ['azul cielo', '#87ceeb'], ['azul agua', '#7fd6d9'], ['azul marino', '#1e3a8a'],
    ['verde militar', '#4b5320'], ['verde petroleo', '#298d90'], ['verde limon', '#b6fc01'], ['verde neon', '#b6fc01'],
    ['negro', '#111111'], ['black', '#111111'], ['blanco', '#ffffff'], ['white', '#ffffff'],
    ['gris', '#9ca3af'], ['gray', '#9ca3af'], ['grey', '#9ca3af'],
    ['azul', '#1d4ed8'], ['blue', '#1d4ed8'], ['celeste', '#7cc4f2'], ['turquesa', '#14b8a6'],
    ['verde', '#16a34a'], ['green', '#16a34a'], ['rojo', '#dc2626'], ['red', '#dc2626'], ['vino', '#7f1d1d'],
    ['rosa', '#f9a8d4'], ['pink', '#f9a8d4'], ['fucsia', '#e0218a'], ['fusia', '#e0218a'],
    ['lila', '#b8a2e3'], ['morado', '#7c3aed'], ['violeta', '#7c3aed'], ['purple', '#7c3aed'],
    ['naranja', '#f97316'], ['orange', '#f97316'], ['amarillo', '#facc15'], ['yellow', '#facc15'],
    ['beige', '#e8d8b0'], ['crema', '#f5ecd7'], ['dorado', '#d4af37'], ['oro', '#d4af37'], ['gold', '#d4af37'],
    ['cafe', '#7c4a2d'], ['marron', '#7c4a2d'], ['brown', '#7c4a2d']
  ];

  function norm(s) {
    return String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/\s+/g, ' ').trim();
  }

  function colorFor(name) {
    var n = norm(name);
    if (!n) return null;
    var sw = win.__NX_SWATCH__ || {};
    for (var k in sw) {
      if (Object.prototype.hasOwnProperty.call(sw, k) && sw[k] && norm(k) === n) return sw[k];
    }
    if (/^#([0-9a-f]{3}|[0-9a-f]{6})$/.test(n)) return n;
    for (var i = 0; i < MAP.length; i++) {
      if (n.indexOf(MAP[i][0]) !== -1) return MAP[i][1];
    }
    return null;
  }

  function paintSwatches(scope) {
    (scope || doc).querySelectorAll('.neb-swatch[data-color], [data-nx-dot]').forEach(function (s) {
      if (s.getAttribute('data-nx-hex')) return;
      var c = colorFor(s.getAttribute('data-color') || s.getAttribute('data-nx-dot'));
      if (!c) return;
      s.style.background = c;
      s.setAttribute('data-nx-hex', c);
      if (/^#f/i.test(c) || c === '#ffffff') s.classList.add('is-light');
    });
  }
  paintSwatches();
  ready(function () { paintSwatches(); });

  /* ---------- 3. Tarjetas: elegir variante y agregar ---------- */
  function closePickers(except) {
    doc.querySelectorAll('[data-nx-pickbox]').forEach(function (box) {
      if (box === except) return;
      box.hidden = true;
      var f = box.closest('form');
      var b = f && f.querySelector('[data-nx-pick]');
      if (b) b.setAttribute('aria-expanded', 'false');
    });
  }

  doc.addEventListener('click', function (e) {
    var pickBtn = e.target.closest('[data-nx-pick]');
    if (pickBtn) {
      var form = pickBtn.closest('form');
      var box = form && form.querySelector('[data-nx-pickbox]');
      if (box) {
        e.preventDefault();
        e.stopPropagation();
        var open = box.hidden;
        closePickers(box);
        box.hidden = !open;
        pickBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (open) {
          paintSwatches(box);
          var first = box.querySelector('.nx-pick__opt:not([disabled])');
          if (first) first.focus({ preventScroll: true });
        }
        return;
      }
    }

    var opt = e.target.closest('.nx-pick__opt');
    if (opt && !opt.closest('.nx-qa')) {
      e.preventDefault();
      e.stopPropagation();
      if (opt.disabled) return;
      var f = opt.closest('form');
      var vid = f && f.querySelector('[data-nx-vid]');
      if (!vid) return;
      vid.value = opt.getAttribute('data-vid');
      var b = f.querySelector('[data-nx-pick]');
      closePickers();
      if (f.requestSubmit) f.requestSubmit(b || undefined);
      else f.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
      return;
    }

    if (e.target.closest('[data-nx-pickclose]')) {
      e.preventDefault();
      closePickers();
      return;
    }

    if (!e.target.closest('[data-nx-pickbox]')) closePickers();
  }, true);

  doc.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closePickers();
  });

  /* ---------- 4. Menú superior desplazable ---------- */
  var ARROW = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 6l6 6-6 6"/></svg>';

  function hScroll(el) {
    if (el.__nxHs) return;
    el.__nxHs = true;

    var wrap = doc.createElement('div');
    wrap.className = 'nx-hs';
    el.parentNode.insertBefore(wrap, el);
    wrap.appendChild(el);

    var left = doc.createElement('button');
    left.type = 'button';
    left.className = 'nx-hs__btn nx-hs__btn--l';
    left.setAttribute('aria-label', 'Ver enlaces anteriores');
    left.innerHTML = ARROW;
    var right = doc.createElement('button');
    right.type = 'button';
    right.className = 'nx-hs__btn nx-hs__btn--r';
    right.setAttribute('aria-label', 'Ver más enlaces');
    right.innerHTML = ARROW;
    wrap.appendChild(left);
    wrap.appendChild(right);

    function update() {
      var max = el.scrollWidth - el.clientWidth;
      wrap.classList.toggle('can-l', el.scrollLeft > 4);
      wrap.classList.toggle('can-r', el.scrollLeft < max - 4);
    }
    function step(dir) { el.scrollBy({ left: dir * Math.max(160, el.clientWidth * 0.6), behavior: 'smooth' }); }
    left.addEventListener('click', function () { step(-1); });
    right.addEventListener('click', function () { step(1); });

    el.addEventListener('scroll', update, { passive: true });
    win.addEventListener('resize', update);

    el.addEventListener('wheel', function (e) {
      if (el.scrollWidth <= el.clientWidth) return;
      if (Math.abs(e.deltaY) > Math.abs(e.deltaX)) {
        el.scrollLeft += e.deltaY;
        e.preventDefault();
      }
    }, { passive: false });

    var down = false, startX = 0, startLeft = 0, moved = 0;
    el.addEventListener('mousedown', function (e) {
      if (e.button !== 0) return;
      down = true; moved = 0; startX = e.clientX; startLeft = el.scrollLeft;
    });
    win.addEventListener('mousemove', function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      moved = Math.max(moved, Math.abs(dx));
      if (moved > 4) { el.scrollLeft = startLeft - dx; el.classList.add('is-drag'); }
    });
    win.addEventListener('mouseup', function () {
      if (!down) return;
      down = false;
      setTimeout(function () { el.classList.remove('is-drag'); }, 0);
    });
    el.addEventListener('click', function (e) {
      if (moved > 4) { e.preventDefault(); e.stopPropagation(); moved = 0; }
    }, true);
    el.addEventListener('dragstart', function (e) { e.preventDefault(); });

    var cur = el.querySelector('[aria-current="page"]');
    if (cur) el.scrollLeft = Math.max(0, cur.offsetLeft - 40);
    update();
    setTimeout(update, 400);
  }

  ready(function () {
    doc.querySelectorAll('.nx-nav__links').forEach(hScroll);
  });

  /* ---------- 5. Colecciones: "Seleccionar opciones" sin salir de la página ---------- */
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function money(cents) { return '$' + Math.round(cents / 100).toLocaleString('en-US') + ' COP'; }
  function imgUrl(src, w) {
    if (!src) return '';
    src = String(src);
    if (src.indexOf('//') === 0) src = 'https:' + src;
    return src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=' + w;
  }

  var qa = null;
  var qaOpener = null;
  function closeQA() {
    if (!qa) return;
    qa.hidden = true;
    doc.documentElement.classList.remove('nx-qa-lock');
    if (qaOpener) { try { qaOpener.focus({ preventScroll: true }); } catch (e) {} }
  }
  function ensureQA() {
    if (qa) return qa;
    qa = doc.createElement('div');
    qa.className = 'nx-qa';
    qa.hidden = true;
    qa.innerHTML = '<div class="nx-qa__bg" data-nx-qaclose></div><div class="nx-qa__box" role="dialog" aria-modal="true" aria-label="Elige una opción"><button type="button" class="nx-qa__x" data-nx-qaclose aria-label="Cerrar">&times;</button><div class="nx-qa__body"></div></div>';
    doc.body.appendChild(qa);
    qa.addEventListener('click', function (e) {
      if (e.target.closest('[data-nx-qaclose]')) { e.preventDefault(); closeQA(); return; }
      var opt = e.target.closest('.nx-qa .nx-pick__opt');
      if (!opt || opt.disabled) return;
      e.preventDefault();
      addFromQA(opt);
    });
    doc.addEventListener('keydown', function (e) { if (e.key === 'Escape' && qa && !qa.hidden) closeQA(); });
    return qa;
  }

  function renderQA(p) {
    var body = ensureQA().querySelector('.nx-qa__body');
    var optName = (p.options && p.options[0] && (p.options[0].name || p.options[0])) || 'Opción';
    var isColor = /colou?r/i.test(optName);
    var opts = (p.variants || []).map(function (v) {
      var dot = isColor ? '<span class="nx-pick__dot" data-nx-dot="' + esc(v.option1) + '"></span>' : '';
      return '<button type="button" class="nx-pick__opt" data-vid="' + v.id + '"' + (v.available ? '' : ' disabled') + ' data-img="' + esc(v.featured_image ? imgUrl(v.featured_image.src, 400) : '') + '">' + dot + esc(v.title) + '</button>';
    }).join('');
    var first = (p.variants || []).filter(function (v) { return v.available; })[0] || p.variants[0];
    body.innerHTML =
      '<div class="nx-qa__head"><img class="nx-qa__img" alt="" width="84" height="84" src="' + esc(imgUrl(p.featured_image, 300)) + '">' +
      '<div><p class="nx-qa__title">' + esc(p.title) + '</p><p class="nx-qa__price">' + money(first ? first.price : p.price) + '</p></div></div>' +
      '<p class="nx-pick__t">Elige ' + esc(String(optName).toLowerCase()) + ' y se agrega al carrito</p>' +
      '<div class="nx-pick__opts nx-qa__opts">' + opts + '</div>' +
      '<p class="nx-qa__msg" role="status" hidden></p>' +
      '<a class="nx-qa__more" href="' + esc(p.url || ('/products/' + p.handle)) + '">Ver detalles del producto</a>';
    paintSwatches(body);
    body.querySelectorAll('.nx-pick__opt').forEach(function (b) {
      b.addEventListener('mouseenter', function () {
        var im = b.getAttribute('data-img');
        if (im) body.querySelector('.nx-qa__img').src = im;
      });
    });
  }

  function addFromQA(opt) {
    var body = qa.querySelector('.nx-qa__body');
    var msg = body.querySelector('.nx-qa__msg');
    body.querySelectorAll('.nx-pick__opt').forEach(function (b) { b.classList.remove('is-loading'); });
    opt.classList.add('is-loading');
    msg.hidden = true;
    var drawer = doc.querySelector('cart-drawer');
    var payload = { items: [{ id: Number(opt.getAttribute('data-vid')), quantity: 1 }] };
    if (drawer && drawer.getSectionsToRender) {
      payload.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
      payload.sections_url = win.location.pathname;
    }
    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok) throw new Error((j && (j.description || j.message)) || 'No se pudo agregar al carrito.');
        return j;
      });
    }).then(function (j) {
      closeQA();
      fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) { setCounts(c.item_count); })
        .catch(function () {});
      if (drawer && drawer.renderContents && j.sections) {
        j.id = payload.items[0].id;
        drawer.renderContents(j);
        var inner = drawer.querySelector('.drawer__inner');
        if (drawer.classList.contains('is-empty')) drawer.classList.remove('is-empty');
        if (inner && inner.classList.contains('is-empty')) inner.classList.remove('is-empty');
      } else {
        win.location.href = '/cart';
      }
    }).catch(function (err) {
      msg.textContent = err.message;
      msg.hidden = false;
    }).then(function () { opt.classList.remove('is-loading'); });
  }

  doc.addEventListener('click', function (e) {
    var btn = e.target.closest('modal-opener[data-modal^="#QuickAdd"] [data-product-url]');
    if (!btn) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var url = String(btn.getAttribute('data-product-url') || '').split('?')[0];
    if (!url) return;
    qaOpener = btn;
    btn.classList.add('loading');
    var sp = btn.querySelector('.loading__spinner');
    if (sp) sp.classList.remove('hidden');
    fetch(url + '.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error(); return r.json(); })
      .then(function (p) {
        renderQA(p);
        qa.hidden = false;
        doc.documentElement.classList.add('nx-qa-lock');
        var f = qa.querySelector('.nx-pick__opt:not([disabled])');
        if (f) f.focus({ preventScroll: true });
      })
      .catch(function () { win.location.href = url; })
      .then(function () {
        btn.classList.remove('loading');
        if (sp) sp.classList.add('hidden');
      });
  }, true);

  /* ---------- 6. Colecciones y búsqueda: filtros y orden ---------- */
  function submitFilters(form) {
    form.querySelectorAll('input[type="number"]').forEach(function (i) { if (i.value === '') i.disabled = true; });
    form.classList.add('is-loading');
    if (form.requestSubmit) form.requestSubmit(); else form.submit();
  }
  doc.addEventListener('change', function (e) {
    var form = e.target.closest && e.target.closest('[data-nx-filters]');
    if (!form) return;
    if (e.target.matches('[data-nx-sort]') || e.target.matches('[data-nx-auto-submit]')) submitFilters(form);
  });
  doc.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('[data-nx-filters]');
    if (!form) return;
    form.querySelectorAll('input[type="number"]').forEach(function (i) { if (i.value === '') i.disabled = true; });
  }, true);
  doc.addEventListener('toggle', function (e) {
    var d = e.target;
    if (!d.matches || !d.matches('[data-nx-fd]')) return;
    if (d.open) doc.querySelectorAll('[data-nx-fd][open]').forEach(function (o) { if (o !== d) o.open = false; });
    doc.documentElement.classList.toggle('nx-fd-open', !!doc.querySelector('[data-nx-fd][open]'));
  }, true);
  doc.addEventListener('click', function (e) {
    var fd = e.target.closest('[data-nx-fd]');
    if (fd && e.target === fd) { fd.open = false; return; } /* fondo oscuro en celular */
    if (fd) return;
    doc.querySelectorAll('[data-nx-fd][open]').forEach(function (o) { o.open = false; });
  });
  doc.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') doc.querySelectorAll('[data-nx-fd][open]').forEach(function (o) { o.open = false; });
  });

  /* ---------- 7. "Ver más productos" sin recargar la página ---------- */
  doc.addEventListener('click', function (e) {
    var more = e.target.closest('[data-nx-more]');
    if (!more || !win.fetch || !win.DOMParser) return;
    var wrap = more.closest('[data-nx-more-wrap]');
    var grid = doc.querySelector('[data-nx-results]');
    if (!grid || !wrap) return;
    e.preventDefault();
    if (more.classList.contains('is-loading')) return;
    more.classList.add('is-loading');
    var label = more.textContent;
    more.textContent = 'Cargando…';
    fetch(more.href, { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(); return r.text(); })
      .then(function (html) {
        var page = new DOMParser().parseFromString(html, 'text/html');
        var items = page.querySelectorAll('[data-nx-results] > li');
        items.forEach(function (li) { grid.appendChild(doc.importNode(li, true)); });
        paintSwatches(grid);
        var total = parseInt(more.getAttribute('data-total'), 10) || 0;
        var shown = grid.children.length;
        var s = wrap.querySelector('[data-nx-shown]');
        if (s) s.textContent = shown;
        var bar = wrap.querySelector('[data-nx-bar]');
        if (bar && total) bar.style.width = Math.min(100, Math.round(shown * 100 / total)) + '%';
        var next = page.querySelector('[data-nx-more]');
        if (next) {
          more.href = next.getAttribute('href');
          more.textContent = label;
          more.classList.remove('is-loading');
        } else {
          more.remove();
        }
      })
      .catch(function () { win.location.href = more.href; });
  });

  /* ---------- 8. Reseñas: "Escribir una reseña" abre el formulario de Judge.me ---------- */
  doc.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-nx-write]');
    if (!btn) return;
    var box = doc.getElementById(btn.getAttribute('aria-controls'));
    if (!box) return;
    e.preventDefault();
    var open = box.hidden;
    box.hidden = !open;
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (!open) return;
    var tries = 0;
    (function openForm() {
      var link = box.querySelector('.jdgm-write-rev-link, [class*="jdgm-write-rev"]');
      var form = box.querySelector('.jdgm-form-wrapper, .jdgm-form');
      if (link && (!form || form.offsetParent === null)) link.click();
      if (!link && tries++ < 20) return setTimeout(openForm, 250);
      box.scrollIntoView({ behavior: 'smooth', block: 'start' });
    })();
  });

  /* ---------- 9. Fuera del producto: el carrito lateral se abre al agregar ---------- */
  function dawnDrawer() {
    if (win.NebulixPDP && doc.querySelector('[data-cart-drawer]')) return null;
    if (/\/cart\/?$/.test(win.location.pathname)) return null;
    var d = doc.querySelector('cart-drawer');
    return d && d.renderContents ? d : null;
  }
  function openDawnDrawer(variantId) {
    var d = dawnDrawer();
    if (!d) return false;
    var ids = d.getSectionsToRender().map(function (s) { return s.id; }).join(',');
    var count = 0;
    fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        count = c.item_count || 0;
        setCounts(count);
        return fetch(win.location.pathname + '?sections=' + ids, { credentials: 'same-origin' });
      })
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        d.classList.toggle('is-empty', count === 0);
        d.renderContents({ id: variantId, sections: sections });
        var inner = d.querySelector('.drawer__inner');
        if (inner) inner.classList.toggle('is-empty', count === 0);
      })
      .catch(function () { win.location.href = '/cart'; });
    return true;
  }
  /* Barra de envío gratis dentro del carrito lateral (igual a la del producto) */
  var FREE_FROM = 20000000; /* $200.000 en centavos */
  function shipBar(d, total) {
    var head = d.querySelector('.drawer__header, .title-wrapper-with-link');
    if (!head) return;
    var bar = d.querySelector('.nx-dship');
    if (!bar) {
      bar = doc.createElement('div');
      bar.className = 'nx-dship';
      head.insertAdjacentElement('afterend', bar);
    }
    var left = Math.max(0, FREE_FROM - total);
    var pct = Math.min(100, Math.round(total * 100 / FREE_FROM));
    bar.innerHTML = left > 0
      ? '<p>Te faltan <b>' + money(left) + '</b> para el <b>envío gratis</b></p><span><i style="width:' + pct + '%"></i></span>'
      : '<p class="is-ok">¡Tienes <b>envío gratis</b>!</p><span><i style="width:100%"></i></span>';
  }
  function shipRoots() {
    var out = [];
    var d = doc.querySelector('cart-drawer');
    if (d && !(win.NebulixPDP && doc.querySelector('[data-cart-drawer]')) && !/\/cart\/?$/.test(win.location.pathname)) out.push(d);
    var page = doc.querySelector('cart-items.is-empty') ? null : doc.querySelector('#main-cart-items');
    if (page) out.push(page.closest('.shopify-section') || page);
    return out;
  }
  function refreshShip() {
    var roots = shipRoots();
    if (!roots.length) return;
    fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        roots.forEach(function (root) {
          if (c.item_count > 0) shipBar(root, c.total_price);
          else { var b = root.querySelector('.nx-dship'); if (b) b.remove(); }
        });
        setCounts(c.item_count);
      })
      .catch(function () {});
  }
  var shipT;
  ready(function () {
    var roots = shipRoots();
    if (!roots.length) return;
    refreshShip();
    var mo = new MutationObserver(function (list) {
      var own = list.every(function (m) { return m.target.closest && m.target.closest('.nx-dship'); });
      if (own) return;
      clearTimeout(shipT);
      shipT = setTimeout(refreshShip, 300);
    });
    roots.forEach(function (r) { mo.observe(r, { childList: true, subtree: true }); });
  });

  ready(function () {
    if (doc.querySelector('cart-drawer') && !doc.querySelector('[data-cart-drawer]') && !/\/cart\/?$/.test(win.location.pathname)) doc.documentElement.classList.add('nx-dawn-drawer');
    doc.querySelectorAll('[data-nx-cart]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var d = dawnDrawer();
        if (!d) return;
        e.preventDefault();
        openDawnDrawer();
      });
    });
  });
  doc.addEventListener('nebulix:cart:added', function (e) {
    var it = e.detail || {};
    openDawnDrawer(it.variant_id || it.id);
  });
})();
